/* action type */
export const SAVE_AND_CLOSE = 'SAVE_AND_CLOSE';

/* action creator */
export const saveAndCloseAction = (actionPayload: { [key: string]: any }) => {
  return {
    type: SAVE_AND_CLOSE,
    payload: actionPayload
  };
};
